<template>
    <div class="tooltipElement">
        <select
            v-model="selectedPlaceholderId"
            @change="setPlaceholder"
        >
            <option value="noPlaceholder">{{ $t('editorSceneElementOptionsNoPlaceholder') }}</option>
            <option
                v-for="placeholder in getPlaceholders"
                :key="placeholder.id"
                :value="placeholder.id"
            >
                {{ placeholder.name }}
            </option>
        </select>
        <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsSetPlaceholder') }`" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Tooltip from '@/components/Global/Tooltip.vue';

    export default {
        data() {
            return {
                selectedPlaceholderId: 'noPlaceholder',
                selectedPlaceholderSystemName: 'noPlaceholder',
                selectedPlaceholderName: 'noPlaceholder'
            }
        },
        methods: {
            elements() {
                const pages = this.getPages;
                let elements = [];
                pages.forEach(page => {
                    const placeholderUserInputs = page.content.elements.filter(element => element.placeholder !== undefined).filter(element => element.placeholder.hasPlaceholder === true);
                    elements = [...elements, ...placeholderUserInputs]
                });

                let placeholders = elements.map(el => ({
                    placeholderObj: el.placeholder,
                    content: this.getPlaceholderUserInputs !== null ? el.content : 'Placeholder content',
                    ids: [],
                    hasError: false,
                    errorMessage: null
                }));
                
                placeholders = placeholders.map(placeholder => {
                    const placeholderSystemName = placeholder.placeholderObj.placeholderSystemName;

                    const elementsForPlaceholders = elements.filter(el => el.placeholder.placeholderSystemName === placeholderSystemName);

                    let ids = [];
                    elementsForPlaceholders.forEach(el => ids.push(el.id));
                    
                    return {
                        ...placeholder,
                        ids
                    }
                })

                let uniquePlaceholders = placeholders.filter((el, i, arr) => {
                    return arr.findIndex(obj => obj.placeholderObj.placeholderId === el.placeholderObj.placeholderId) === i
                });

                uniquePlaceholders.map(placeholder => {
                    const newestPlaceholderValues = this.getPlaceholders.find(item => item.id === placeholder.placeholderObj.placeholderId).name;
                    placeholder.placeholderObj.placeholderName = newestPlaceholderValues;
                });

                return uniquePlaceholders;
            },
            setPlaceholder() {
                this.$nextTick(() => {
                    this.$store.dispatch('SET_PLACEHOLDER_USER_INPUTS', this.elements());
                    if (this.getActiveElement.type === 'TEXT_ELEMENT') {
                        if (this.selectedPlaceholderId !== 'noPlaceholder') {
                            
                            const content = this.getPlaceholderUserInputs.find(pl => pl.placeholderObj.placeholderSystemName === this.selectedPlaceholderSystemName).content;
                            let textPayload = {
                                id: this.getActiveElement.id,
                                content
                            }

                            this.$store.dispatch('CHANGE_TEXT', textPayload)
                        }
                    }
                });
                
                this.selectedPlaceholderSystemName = this.selectedPlaceholderId === 'noPlaceholder' ? 'noPlaceholder' : this.getPlaceholders.find(placeholder => placeholder.id === this.selectedPlaceholderId).systemName;
                this.selectedPlaceholderName = this.selectedPlaceholderId === 'noPlaceholder' ? 'noPlaceholder' : this.getPlaceholders.find(placeholder => placeholder.id === this.selectedPlaceholderId).name;

                const payload = {
                    placeholderId: this.selectedPlaceholderId,
                    placeholderSystemName: this.selectedPlaceholderSystemName,
                    placeholderName: this.selectedPlaceholderName
                }
                this.$store.dispatch('SET_TEXT_PLACEHOLDER', payload);
            }
        },
        computed: {
            ...mapGetters([
                'getSessionDetails',
                'getActiveElement',
                'getPlaceholderUserInputs',
                'getPages',
                'getPlaceholders'
            ])
        },
        watch: {
            getActiveElement: {
                deep: true,
                handler: function() {
                    this.selectedPlaceholderId = this.getActiveElement.placeholder.placeholderId;
                    this.selectedPlaceholderSystemName = this.getActiveElement.placeholder.placeholderSystemName;
                    this.selectedPlaceholderName = this.getActiveElement.placeholder.placeholderName;
                }
            }
        },
        mounted() {
            this.selectedPlaceholderId = this.getActiveElement.placeholder.placeholderId;
        },
        components: {
            Tooltip
        }
    }
</script>

<style scoped>
    select {
        width: 100%;
        background-color: #f5f5f5;
        border: none;
        box-sizing: border-box;
        font-size: 12px;
        padding: 7px 10px 7px 7px;
    }
</style>